import { DependencyList, useMemo } from "react";
import stringify from "fast-json-stable-stringify";

export function useMemoByValue<T>(factory: () => T, deps: DependencyList): T {
    return useMemo(factory, [stringify(deps)]);
}
